// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6716 ? "f4898fe8" : chunkId) + "." + {"2432":"02565ddd41164823","3679":"739caf07978d2c83","6716":"cc9ff084f6be4bdf","8309":"e9ca1cfb33d894ba"}[chunkId] + ".js";
};